import NFTCollectionsList from '../../../data/NFTCollectionsList'
import INFTCollections from '../../../models/INFTCollections'
import INFTDetailFormatDetector from './INFTDetailFormatDetector'

export function NFTDetailFormatDetector({
  tokenItem,
  detailsLoading,
  tokenContract
}: INFTDetailFormatDetector): JSX.Element {
  const foundedCollection: INFTCollections | undefined = NFTCollectionsList.find(
    (item: INFTCollections) => item.tokenAddress.toLowerCase() === tokenContract.toLocaleLowerCase()
  )

  return foundedCollection
    ? foundedCollection.detailFormat({ tokenItem, detailsLoading, collection: foundedCollection })
    : NFTCollectionsList[0].detailFormat({ tokenItem, detailsLoading, collection: NFTCollectionsList[0] })
}
